import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { showNotification } from '@mantine/notifications';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { ministrySchedulerService } from '@/services/ministry-scheduler.service';
import type { MinistrySchedulerUpdateRequest } from '@/types/ministryScheduler';

export const useMinistryScheduler = (churchId: string | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEYS.MINISTRY_SCHEDULER, churchId],
    queryFn: () => ministrySchedulerService.getMinistryScheduler(churchId ?? ''),
    enabled: !!churchId,
  });
};

export const useUpdateMinistrySchedulerMutation = (churchId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: MinistrySchedulerUpdateRequest) =>
      ministrySchedulerService.updateMinistryScheduler(churchId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.MINISTRY_SCHEDULER, churchId] });
      showNotification({ title: 'Success', message: 'Ministry Scheduler updated successfully', color: 'green' });
    },
  });
};
